import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import globalMessages from 'translations/messages';
import { Tooltip, Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

import './loading.less';

const Loading = ({
  descriptionTimeout = 6000,
  buttonTimeout = 6000,
  children,
  style,
  cover,
  fullsize = true,
}) => {
  const [showDescription, setShowDescription] = useState(false);
  const [showClose, setShowClose] = useState(false);

  const [isClosed, setIsClosed] = useState(false);

  // Show loading description
  useEffect(() => {
    const killme = setTimeout(() => {
      setShowDescription(true);
    }, descriptionTimeout);
    return () => {
      clearTimeout(killme);
    };
  });

  // Show close loading button
  useEffect(() => {
    const killme = setTimeout(() => {
      setShowClose(true);
    }, buttonTimeout);
    return () => {
      clearTimeout(killme);
    };
  });

  const handleClickLoadingContainer = (event) => {
    // Secret combination! ctrl/shift/alt click to hide the loading faster
    event.stopPropagation();
    if (event.ctrlKey || event.shiftKey || event.altKey) {
      setIsClosed(true);
    }
  };

  if (isClosed) return null;

  return (
    <div
      className={`loading ${fullsize ? 'fullsize' : ''} ${cover ? 'loading--cover' : ''}`}
      role="presentation"
      onClick={handleClickLoadingContainer}
      style={style}
    >
      <div className="loading__text">
        <FormattedMessage {...globalMessages.loading} />
      </div>
      <div className="loading__container">
        <div className="loading__bar" />
      </div>
      {showDescription && (
      <div className="loading__description">
        <FormattedMessage {...globalMessages.loadingDescription} />
      </div>
      )}
      {showClose && (
      <div className="loading__close">
        <Tooltip title={<FormattedMessage {...globalMessages.closeLoadingTooltip} />}>
          <Button type="primary" size="small" onClick={() => setIsClosed(true)}>
            <CloseOutlined />
            <FormattedMessage {...globalMessages.closeLoading} />
          </Button>
        </Tooltip>
      </div>
      )}
      {children}
    </div>
  );
};

export default Loading;
